<template>
  <el-upload
    title="最多上传5个附件，单文件最大20M"
    ref="up"
    style="display:inline-block;"
    action="//upload.qiniup.com"
    multiple
    :data="token"
    :before-upload="beforeUpload"
    :on-success="uploadSuccess"
    :on-remove="handleRemove"
    :file-list="fileList">
    <el-button>上传附件</el-button>
  </el-upload>
</template>

<script>
export default {
  name: "TicketUpload",

  props : ['ticketUploadList'],

  data() {
    return {
      attachmentList : [],
      fileList: [], // 已上传凭证列表-添加回复
      token: null
    };
  },

  methods: {
    setFileList(_files) {
      this.fileList = _files;
    },

    //获取文件后缀名
    getSuffix(file) {
      var lastPlace = file.lastIndexOf("."), fileLength = file.length;
      return file.substring(lastPlace + 1, fileLength)    
    },

    beforeUpload(file) {
      this.getToken(file);
    },

    //获取上传七牛token
    getToken(file) {
      var isBig = file.size/1024/1024 < 100
      if(!isBig) {
        _message('上传文件大小不能超过100MB!')
        return isBig
      }

      this.getToken_0(this.getSuffix(file.name));
    },

    getToken_0(_suffix) {
      var _this = this;
      sdk.QiniuApi().qiniuToken({
        suffix : _suffix
      }).then(resp => {
        _this.token = resp;
        _this.uploaderDomain = resp.domain;
      });
    },

    //上传七牛成功执行回调函数
    uploadSuccess (response, file, fileList) {
      var uploadUrl = this.uploaderDomain + '/' + response.key;
      this.attachmentList.push({'fileName': file.name, 'filePath': uploadUrl});

      if ( !!this.ticketUploadList ) {
        this.ticketUploadList.setAttachmentList(this.attachmentList);
      }

      this.$emit('change', this.attachmentList);
    },

    clearFile() {
      this.attachmentList = [];
      this.fileList = [];
    },

    deleteFile(e) {
      var len = this.attachmentList.length;

      for ( var i = 0; i < len; i++ ) {
        var each = this.attachmentList[i];
        if ( e.fileName == each.fileName && e.filePath == each.filePath ) {
          this.attachmentList.splice(i, 1);
        }
      }
    },

    // 删除图片后回调 - 添加回复
    handleRemove(file, fileList) {
      console.log('# TicketUpload handleRemove, file=', file, 'fileList=', fileList);

      this.attachmentList = [];
      this.fileList = [];

      fileList.map((item)=> {
        if ( item.response ) {
          this.attachmentList.push({'fileName': item.name, 'filePath': this.uploaderDomain + '/' + item.response.key})
          this.fileList.push({'name': item.name, 'url': this.uploaderDomain + '/' + item.response.key})
        } else {
          this.attachmentList.push({'fileName': item.name, 'filePath': item.url})
          this.fileList.push({'name': item.name, 'url': item.url})
        }
      })
    },

    getAttachmentList() {
      return this.attachmentList;
    }
  },

  mounted() {
    this.getToken_0();
  }
};
</script>

<style>
.el-upload-list--text {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketUpload.vue